import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@mui/styles';
import {
  Avatar,
  Button,
  useMediaQuery,
  Grid2 as Grid,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
  List,
  colors
} from '@mui/material';
import { alpha } from '@mui/material/styles';

import { IconAlternate, SectionHeader } from 'components/molecules';

const useStyles = makeStyles(theme => ({
  listItem: {
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  listItemAvatar: {
    marginRight: theme.spacing(0),
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginBottom: theme.spacing(2),
    },
  },
  listItemText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    margin: 0,
    height: '100%',
  },
  title: {
    fontWeight: 'bold',
  },
}));


const StepCard = ({ icon, title, description }) => {  
  return (
    <Box >
      {/* Angled Header */}
      <Box
        sx={{
          backgroundColor: 'primary.main',
          clipPath: 'polygon(0 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 0 100%, 20px 50%)',
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'secondary.main',
          mb: 2,
          px: 4, // Add some horizontal padding
        }}
      >
        {icon}
      </Box>
      <Typography
        variant={'h5'}
        gutterBottom
        sx={{ fontWeight: 700 }}
      >
        {title}
      </Typography>
      <Typography color="text.secondary">{description}</Typography>

    </Box>
  );
};


const FinalSteps = props => {
  const { data, className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <SectionHeader
        title="From Setup to Sales: The Final Steps"
        subtitle=""
      />
      <Grid container spacing={isMd ? 2 : 1}>
        {data.map((item, index) => (
          <Grid key={index} size={{ xs: 12, sm: 4, md: 4 }}>
            <StepCard icon={item.icon} title={item.title} description={item.description} />            
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

FinalSteps.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default FinalSteps;
